module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Also by the same author")])]), _vm._v(" "), _c('p', {
    staticClass: "hangp"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hunting from Hampstead: The Story of Henry and Lucy Stedall and their Children")]), _vm._v(" (Book Guild Publishing, 2002)")]), _vm._v(" "), _c('p', {
    staticClass: "hangp"
  }, [_vm._v("A two-volume history of Mary Queen of Scots:")]), _vm._v(" "), _c('p', {
    staticClass: "hangp"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Challenge to the Crown, Volume I: The Struggle for Influence in the Reign of Mary Queen of Scots 1542–1567")]), _vm._v(" (Book Guild Publishing, 2012)")]), _vm._v(" "), _c('p', {
    staticClass: "hangp"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Survival of the Crown, Volume II: The Return to Authority of the Scottish Crown Following Mary Queen of Scots’ Deposition from the Throne")]), _vm._v(" (Book Guild Publishing, 2014)")]), _vm._v(" "), _c('p', {
    staticClass: "hangp"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Men of Substance: The London Livery Companies’ Reluctant Part in the Plantation of Ulster")]), _vm._v(" (Austin Macauley Publishers, 2016)")]), _vm._v(" "), _c('p', {
    staticClass: "hangp"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Queen of Scots’ Downfall: The Life and Murder of Henry, Lord Darnley")]), _vm._v(" (Pen & Sword Books Limited, 2017)")]), _vm._v(" "), _c('p', {
    staticClass: "hangp"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Roots of Ireland’s Troubles")]), _vm._v(" (Pen & Sword Books Limited, 2019)")]), _vm._v(" "), _c('p', {
    staticClass: "hangp"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Elizabeth I’s Secret Lover: Robert Dudley, Earl of Leicester")]), _vm._v(" (Pen & Sword Books Limited, 2020)")]), _vm._v(" "), _c('p', {
    staticClass: "hangp1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Website")]), _vm._v(": "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.maryqueenofscots.net",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.maryqueenofscots.net")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1c40e92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Author.vue
// module id = 72
// module chunks = 0